import type { SpotPriser, Dag } from "$lib/types/spotPriser";
import { roundToTwoDecimals as round } from "$lib/utils/math";

export type DayData = Map<string, number | undefined>;
export type DaysData = Map<string, DayData>;

export const getMaxPrice = (spotPriser: SpotPriser[]): number =>
  Math.max(
    ...spotPriser.map(
      (x: SpotPriser) =>
        x.dager
          .map((x: Dag) => x.dognpris)
          .reduce((a: number, b: number) => Math.max(a, b), 0)
    )
  );

export const getDaysData = (spotPriser: SpotPriser[], useAreas?: string[]): Map<string, DayData> => {
  const days = spotPriser.length && spotPriser[1]?.dager.map((x: Dag) => x.dato);
  const areas = useAreas?.length ? useAreas : spotPriser
    .map((x: SpotPriser) => x.omrade)
    .filter((x: string) => x !== "SYS");

  return !days ? new Map() : new Map(days.map((isoDay: string) => ([
    isoDay,
    new Map(
      areas.map((areaCode: string) =>
        [
          areaCode,
          round(Number(
            (spotPriser.find((x: SpotPriser) => x.omrade === areaCode)?.dager.find((d: Dag) => d.dato === isoDay) || {}).dognpris
            || 0
          ))
        ]
      )
    )
  ])));
};
